module.exports = __webpack_public_path__ + "static/media/OurAchievements_Tablet.6cb329af.svg";